import Api from "@/helpers/api.js";

import {payloadGenerator} from "@/helpers/payloadGenerator";

export default {
	async fetchScheduleFollowers({commit}, params = {}) {
		try {
			if (!params.order_by) {
				params.order_by = ["event_id"];
			}

			const payload = payloadGenerator(params, "Follower");

			const response = await Api.post("/schedule_followers/filter", payload);

			if (response.status === 201) {
				commit("SET_SCHEDULE_FOLLOWERS", response.data.records);
			}

			return response;
		} catch (error) {
			console.error("Error fetching schedule followers:", error);
		}
	},
	async fetchScheduleFollowerById({commit}, followerId) {
		try {
			const params = {
				filters: {
					id: [followerId],
				},
			};
			const payload = payloadGenerator(params, "Follower");

			const response = await Api.post("/schedule_followers/filter", payload);

			return response;
		} catch (error) {
			console.error("Error fetching schedule follower by ID:", error);
		}
	},
	async createScheduleFollower({commit}, follower) {
		try {
			const payload = payloadGenerator(follower, "Follower", "create");

			const response = await Api.post("/schedule_followers", payload);

			if (response.status === 200) {
				commit("CREATE_SCHEDULE_FOLLOWER", follower);
			}

			return response;
		} catch (error) {
			console.error("Error creating schedule follower:", error);
			return error;
		}
	},

	async updateScheduleFollower({commit}, follower) {
		try {
			const payload = payloadGenerator(follower, "Follower", "update");

			const response = await Api.put(`/schedule_followers/${follower.id}`, payload);

			if (response.status === 200) {
				commit("UPDATE_SCHEDULE_FOLLOWER", follower);
			}
			return response;
		} catch (error) {
			console.error("Error updating schedule follower:", error);
		}
	},

	async deleteScheduleFollower({commit}, followerId) {
		try {
			const response = await Api.delete(`/schedule_followers/${followerId}`);

			if (response.status === 200) {
				commit("DELETE_SCHEDULE_FOLLOWER", followerId);
			}
			return response;
		} catch (error) {
			console.error("Error deleting schedule follower:", error);
		}
	},

	async fetchTemplates({commit}) {
		try {
			const response = await Api.get("/templates");

			if (response.status === 200) {
				commit("SET_TEMPLATES", response.data);
			}

			return response;
		} catch (error) {
			console.error("Error fetching templates:", error);
		}
	},
};
